import { Component, Input, OnInit } from '@angular/core';
import { Company } from '../../../core/models';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-company-logo',
  templateUrl: './company-logo.component.html',
  styleUrls: ['./company-logo.component.scss'],
})
export class CompanyLogoComponent implements OnInit {
  @Input() company: Company;
  @Input() showTitle = false;
  @Input() showTitleFailover = false;
  @Input() showLogo = true;
  @Input() scale = 1;
  @Input() maxTitleLines = 999;
  companyLogo = '';
  companyText = '';
  ngOnInit(): void {
    if (this.company.logo) {
      this.companyLogo = `${environment.companyLogos}${this.company.logo}`;
    }
    this.companyText = this.company.issuer_name;
  }
}
